import React from 'react'
import { useQuery } from 'react-query'
import { RedocStandalone } from 'redoc'

import { skuit } from '../services/skuit'

export const InternalSCAPIDocs = () => {
  const { data, isLoading } = useQuery(['docs-schema'], () => skuit.docs.internal.supplyChain())
  return <>{isLoading ? <div>Loading...</div> : <RedocStandalone spec={data} />}</>
}
